import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CmsNavigationComponent, RoutingService } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { KnBrNavigationService } from 'src/services/kn-br-navigation.service';
import { KnBrSidebarService } from 'src/services/kn-br-sidebar.service';

@Component({
    selector: 'kn-br-navigation',
    templateUrl: './kn-br-navigation.component.html',
    styleUrls: ['./kn-br-navigation.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class KnBrNavigationComponent {
  node$: Observable<any> = this.service.createNavigation(this.componentData.data$);
  styleClass$: Observable<string | undefined> = this.componentData.data$.pipe(map((d) => d?.styleClass));
  istoggleOpen = false;
  constructor(
    protected componentData: CmsComponentData<CmsNavigationComponent>,
    protected service: KnBrNavigationService,
    private sidebarService: KnBrSidebarService,
    private routingService: RoutingService
  ) {}

  toggle(node: any, index: number) {
    this.closeRemainingMenus(index);
    node.active = !node.active;
    this.istoggleOpen = !this.istoggleOpen;
    if (node && node.uid === 'MyAccountPriceListLink') {
      this.sidebarService.changeMenuState(false);
      if (node.url) {
        this.routingService.goByUrl(node.url);
      }
      return;
    }
  }

  closeRemainingMenus(index: number) {
    this.node$.subscribe((res) => {
      if (res && res.children && res.children.length > 0) {
        const nodes: any[] = res.children[0];
        Object.values(nodes)
          .filter((menu, i) => i !== index && menu.active)
          .forEach((menu) => (menu.active = !menu.active));
      }
    });
  }

  onMouseEnter(node: any, index: number) {
    this.closeRemainingMenus(index);
    node.active = true;
  }

  onMouseLeave(node: any, index: number) {
    this.closeRemainingMenus(index);
    node.active = false;
  }
}
